const drawerItems = [
        {
          icon: 'mdi-domain',
          title: 'Organizations',
          to: '/organizations',
        },
        {
          icon: 'mdi-account-multiple',
          title: 'Users',
          to: '/users',
        },
        {
          title: 'DBS Apps',
          icon: 'mdi-apps',
          to: '/app-modules',
        },
        {
          title: 'Our Partners',
          icon: 'mdi-sitemap-outline',
          to: '/partners',
        },
        {
          title: 'DigiBoards',
          icon: 'mdi-monitor-dashboard',
          to: '/digi-boards',
        },
        {
          title: 'Payments',
          icon: 'mdi-credit-card-check ',
          to: '/payments',
        },
        {
          title: 'Knowledge Base',
          icon: 'mdi-notebook',
          to: '/knowledgebase',
        },
        {
          icon: 'mdi-cog',
          title: 'Settings',
          to: '/settings',
        },
        {
          title: 'Widgets',
          icon: 'mdi-widgets',
          to: '/widgets',
        },
        {
          title: 'Support',
          icon: 'mdi-face-agent',
          to: '/support',
        },
        {
          title: 'Blogs',
          icon: 'mdi-post',
          to: '/blogs',
        },
    ];

export default drawerItems;
